import $ from 'static/script/libs/jquery';

function IsTouch() {
    return $('html.touch').length > 0;
}

module.exports = IsTouch;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/is-touch.js